// Blitzcrank — Power Fist: charges up and punches the nearest enemy for heavy physical
// damage and stuns them.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const blitzcrankPunch: Ability = {
  id: "blitzcrankPunch",
  displayName: "Power Fist",
  description: "Charges up and smashes the nearest enemy for heavy physical damage, stunning them.",
  iconId: "PowerFist",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    if (!target) return [];
    const stats = effectiveStats(caster);
    return [{
      target,
      amount: physicalDamage(stats.ad * 1.6 + 80),
      type: "physical",
      effect: { kind: "stun", duration: 1 },
    }];
  },
};
